import { ListItem, ListItemText } from '@material-ui/core';
import React, { ReactElement } from 'react';

import { purple } from 'utils/color-styles';

const Option = ({ content }): ReactElement => (
  <ListItem title={`content.get('name')`}>
    <ListItemText
      primary={
        <div style={{ display: 'flex' }}>
          <div style={{ color: purple }}>{content.get('name')} </div>
        </div>
      }
    />
  </ListItem>
);

export default Option;
